import { RouteObject, createBrowserRouter } from 'react-router-dom';
import Error404 from './pages/error/Error404';
import Error403 from './pages/error/Error403';
import Error500 from './pages/error/Error500';
import App from './App';
import { Suspense, lazy } from 'react';
import KidsaNewsLetter from './components/kidsa/KidsaNewsLetter';
import KidsaTemplate from './pages/ElCristo';
import Waze from './layouts/WazeSharedTrip';
import KidsaModelo from './components/kidsa/KidsaModelo';
import KidsaNosotros from './components/kidsa/KidsaNosotros';
import KidsaAdmision from './components/kidsa/KidsaAdmision';
import KidsaRadio from './components/kidsa/KidsaRadio';
import AdminPanel from './pages/AdminPanel';

const FontAwesomeExample = lazy(
  () => import('./pages/modules/components/FontAwesomeExample')
);

const FeatherIconsExample = lazy(
  () => import('./pages/modules/components/FeatherIconsExample')
);

const UniconsExample = lazy(
  () => import('./pages/modules/components/UniconsExample')
);



const routes: RouteObject[] = [
  {
    element: <App />,
    children: [
      {
      path: '/',
        element:  <KidsaTemplate />,
          children: [
            {
              path: 'admision',
              element: <KidsaAdmision />
            },
            {
              path: 'modelo',
              element: <KidsaModelo />
            },
            {
              path: 'nosotros',
              element: <KidsaNosotros />
            },
            {
              path: 'radio',
              element: <KidsaRadio />
            }
          ]
        },
        {
          path: '/admin/*',
          element: <AdminPanel />
        },
      {
        path: '*',
        element: <Error404 />
      }
    ],
  },
];

export const router = createBrowserRouter(routes);

export default routes;
function setRecognizedText(): void {
  throw new Error('Function not implemented.');
}

function handleTranscript(): void {
  throw new Error('Function not implemented.');
}

